import DashboardsIcon from "@mui/icons-material/Dashboard";
import { MenuItem } from "@mui/material";
import { type FC } from "react";
import { matchPath, NavLink, useLocation } from "react-router";

import { MoreButton } from "~/components/UI/MoreButton";
import { ROUTES } from "~/constants/routing";
import { renderBadge } from "~/feature/categories/components/Categories/utils";
import * as Styled from "~/feature/categories/components/MoreTagsButton/MoreTagsButton.styles";
import { useDashboardsTabs } from "~/feature/dashboards/hooks/useDashboardsTabs";

export const MoreDashboardsButton: FC = () => {
  const dashboardsTabs = useDashboardsTabs();
  const { pathname } = useLocation();
  const isActive = !!matchPath(
    { path: ROUTES.dashboards.path, end: false },
    pathname
  );

  return (
    <MoreButton
      text="Dashboards"
      startIcon={<DashboardsIcon fontSize="small" />}
      arrowIcon={false}
      component={NavLink}
      to={ROUTES.highlights.createURL()}
      isActive={isActive}
    >
      {dashboardsTabs.map((tab) => {
        const TabIcon = tab.icon;

        return (
          <MenuItem
            key={tab.key}
            component={NavLink}
            to={tab.to}
            selected={tab.isActive}
            sx={{ gap: 0.5 }}
          >
            <TabIcon fontSize="small" />
            <Styled.CategoryText variant="caption" $isActive={tab.isActive}>
              {tab.label}
            </Styled.CategoryText>
            {renderBadge(tab.key)}
          </MenuItem>
        );
      })}
    </MoreButton>
  );
};
